module.exports = __webpack_public_path__ + "static/media/2HD.913f16b6.mp4";